import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {SessionService} from '../../../../services/session.service';
import {DateHelper} from '../../../../helper/date.helper';
import {DatePipe} from '@angular/common';
import {DatePicker} from 'primeng/datepicker';

@Component({
  selector: 'app-common-date',
  standalone: true,
  imports: [
    TranslateModule,

    FormsModule,
    DatePicker
  ],
  templateUrl: './common-date.component.html',
  styleUrl: './common-date.component.scss'
})
export class CommonDateComponent implements OnInit
{
  private sessionService = inject(SessionService);
  private datePipe = inject(DatePipe);

  @Input() gridLabel: string;
  @Input() showWeek = true;
  @Input() showIcon: boolean;
  @Input() disabled: boolean;
  @Input() set date(value: Date)
  {
    if (value)
      this.value = new Date(value);
  }
  @Output() dateChange: EventEmitter<string> = new EventEmitter<string>();
  @Input() set dateByString(value: string)
  {
    if (value)
      this.value = new Date(value);
  }
  @Output() dateByStringChange: EventEmitter<string> = new EventEmitter<string>();

  value: any;
  dateFormat: string;

  ngOnInit(): void
  {
    this.dateFormat = this.sessionService.dateFormatCalendar;
  }

  public updateValue(): void
  {
    const newValue = this.value ? DateHelper.toDateApi(this.value, this.datePipe) : undefined;
    console.log('[common-date], updateValue: ' + newValue);
    this.dateChange.emit(newValue);
    this.dateByStringChange.emit(newValue);
  }
}
